export default __webpack_public_path__ + "static/mataha-7df1202efca6dd69f3dfef4efdbb0c76.jpg";